import { Box, Container, Pagination, TextField, Typography, InputAdornment } from '@mui/material';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';

import { fetchWithToken } from 'helpers/fetch';
import { endPoints } from 'const/endPoints';

import Spinner from 'components/common/Spinner';
import EditUser from './EditUser';
import DeleteUser from './DeleteUser';
import UserStatusToggle from './UserStatusToggle';

const Users = () => {
  //*Guardamos la lista de usuarios de la base de datos
  const [users, setUsers] = useState([]);
  const [flag, setFlag] = useState(false);
  const [search, setSearch] = useState('');
  //*fetch para obtener usuarios
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const resp = await fetchWithToken(endPoints.get_all_users);
        if (resp.ok) {
          const data = await resp.json();
          setUsers(Array.isArray(data) ? data : []);
        } else {
          console.error('Error fetching users:', resp.status);
          setUsers([]);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
        setUsers([]);
      }
    };
    fetchUsers();
    //para que se repita cada vez que borre un usuario
    setFlag(false);
  }, [flag]);

  //*Filtrar usuarios por búsqueda
  const filteredUsers = users.filter((user) => {
    if (!search.trim()) return true;
    const term = search.toLowerCase();
    const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
    return (
      fullName.includes(term) ||
      user.username?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term)
    );
  });

  //*Paginacion
  const [page, setPage] = useState(1); //pagina actual
  const n = 6; //Numero de elementos por paginas
  const totalPages = Math.ceil(filteredUsers.length / n); //total de paginas

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  //*Funcion para listar los usuarios por pagina
  const setUsersInPage = () => {
    if (filteredUsers.length === 0) {
      return { 1: [] };
    }

    let pagination = {};
    let j = 0;
    for (let i = 1; i <= totalPages; i++) {
      pagination[i] = filteredUsers.slice(j * n, j * n + n);
      j++;
    }

    return pagination;
  };

  const itemList = setUsersInPage();
  
  // Loading state
  if (!Array.isArray(users)) {
    return <Spinner />;
  }
  
  // Empty state
  if (users.length === 0) {
    return (
      <Container sx={{ padding: '2rem 0', height: '100vh' }}>
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '2rem 0',
            fontSize: '1.5rem',
          }}
        >
          USUARIOS
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '60vh',
          }}
        >
          <Typography variant="h6" color="text.secondary" mb={2}>
            No hay usuarios disponibles
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Verifica la conexión con el servidor o los permisos de usuario
          </Typography>
        </Box>
      </Container>
    );
  }
  return (
    <Container
      sx={{
        padding: '2rem 0',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* //* TITULO */}
      <Typography
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '0 0 1rem 0',
          fontSize: '1.5rem',
        }}
      >
        USUARIOS
      </Typography>

      {/* //* BUSCADOR */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <TextField
          size="small"
          placeholder="Buscar por nombre, usuario o correo..."
          value={search}
          onChange={handleSearch}
          sx={{
            width: '450px',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
              backgroundColor: '#fff',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
              transition: 'box-shadow 0.3s ease',
              '&:hover': {
                boxShadow: '0px 3px 12px rgba(0, 0, 0, 0.12)',
              },
              '&.Mui-focused': {
                boxShadow: '0px 3px 12px rgba(63, 81, 181, 0.2)',
              },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#9e9e9e' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* //* header del historial de compras */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          padding: '1.5rem 0',
          boxShadow: '0px 0px 5px -1px   #999898',
        }}
      >
        <Typography
          sx={{
            width: '14%',
            flexShrink: 0,
            borderRight: 'solid 1px #999898',
            textAlign: 'center',
            padding: '0 0.5rem',
            fontWeight: '600',
          }}
        >
          ID
        </Typography>
        <Typography
          sx={{
            width: '16%',
            flexShrink: 0,
            borderRight: 'solid 1px #999898',
            textAlign: 'center',
            padding: '0 0.5rem',
            fontWeight: '600',
          }}
        >
          Nombre
        </Typography>
        <Typography
          sx={{
            width: '14%',
            flexShrink: 0,
            borderRight: 'solid 1px #999898',
            textAlign: 'center',
            padding: '0 0.5rem',
            fontWeight: '600',
          }}
        >
          Usuario
        </Typography>
        <Typography
          sx={{
            width: '18%',
            flexShrink: 0,
            borderRight: 'solid 1px #999898',
            textAlign: 'center',
            padding: '0 0.5rem',
            fontWeight: '600',
          }}
        >
          Correo
        </Typography>
        <Typography
          sx={{
            width: '12%',
            flexShrink: 0,
            borderRight: 'solid 1px #999898',
            textAlign: 'center',
            padding: '0 0.5rem',
            fontWeight: '600',
          }}
        >
          Rol
        </Typography>
        <Typography
          sx={{
            width: '12%',
            flexShrink: 0,
            borderRight: 'solid 1px #999898',
            textAlign: 'center',
            padding: '0 0.5rem',
            fontWeight: '600',
          }}
        >
          Estado
        </Typography>
        <Typography
          sx={{
            width: '14%',
            flexShrink: 0,
            textAlign: 'center',
            padding: '0 0.5rem',
            fontWeight: '600',
          }}
        >
          Acciones
        </Typography>
      </Box>

      {/* //* Contenido del listado de usuarios */}
      <Box
        sx={{
          margin: '1.5rem 0rem',
          flex: 1,
        }}
      >
        {itemList[page] && Array.isArray(itemList[page]) ? itemList[page].map((item, i) => {
          const color = i % 2 === 0 ? '#F0F0F0' : '#fff';
          return (
            <Box
              key={item.id}
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                margin: '1rem 0rem',
                backgroundColor: color,
                padding: '1rem 0',
                borderTop: 'none',
                borderBottom: 'solid 1px #999898',
              }}
            >
              <Typography
                sx={{
                  width: '14%',
                  flexShrink: 0,
                  textAlign: 'center',
                  padding: '0 0.5rem',
                }}
              >
                {item.id.substring(item.id.length - 4, item.id.length)}
              </Typography>
              <Typography
                sx={{
                  width: '16%',
                  flexShrink: 0,
                  textAlign: 'center',
                  padding: '0 0.5rem',
                }}
              >
                {item.firstName} {item.lastName}
              </Typography>
              <Typography
                sx={{
                  width: '14%',
                  flexShrink: 0,
                  textAlign: 'center',
                  padding: '0 0.5rem',
                }}
              >
                {item.username}
              </Typography>
              <Typography
                sx={{
                  width: '18%',
                  flexShrink: 0,
                  textAlign: 'center',
                  padding: '0 0.5rem',
                  fontSize: '0.8rem',
                }}
              >
                {item.email}
              </Typography>
              <Box
                sx={{
                  width: '12%',
                  flexShrink: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    width: '80%',
                    flexShrink: 0,
                    textAlign: 'center',
                    padding: '0.16rem 0.5rem',
                    backgroundColor: '#999898',
                    borderRadius: '7px',
                    color: '#fff',
                    fontSize: '0.8rem',
                    boxShadow: '0px 0px 3px 0px   #000000',
                  }}
                >
                  {item.role}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: '12%',
                  flexShrink: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    width: 'auto',
                    flexShrink: 0,
                    textAlign: 'center',
                    padding: '0.16rem 0.5rem',
                    backgroundColor: item.isActive !== false ? '#4caf50' : '#f44336',
                    borderRadius: '7px',
                    color: '#fff',
                    fontSize: '0.7rem',
                    boxShadow: '0px 0px 3px 0px   #000000',
                  }}
                >
                  {item.isActive !== false ? 'Activo' : 'Inactivo'}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: '14%',
                  flexShrink: 0,
                  textAlign: 'center',
                  padding: '0 0.5rem',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 0.5,
                }}
              >
                <EditUser user={item} flag={setFlag} />
                <UserStatusToggle user={item} flag={setFlag} />
                <DeleteUser id={item.id} flag={setFlag} />
              </Box>
            </Box>
          );
        }) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
            }}
          >
            <Typography variant="body1" color="text.secondary">
              No hay usuarios para mostrar en esta página
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '1.5rem',
        }}
      >
        <Pagination
          count={totalPages || 1}
          shape="rounded"
          page={page}
          onChange={handleChange}
        />
      </Box>
    </Container>
  );
};

export default Users;
